import { Injectable } from '@angular/core';

import { query, Timestamp, where } from 'firebase/firestore';

import { FirestorePath } from '../../shared/constants/path';
import { User } from '../models/user.model';
import { RootBaseDao } from './root-base.dao';

@Injectable({ providedIn: 'root' })
export class UsersDao extends RootBaseDao<User> {
	collectionName = FirestorePath.Users;

	streamUsersByClient(clientId?: string) {
		return this.collection().streamAll((ref) =>
			clientId
				? query(ref, where('clientIds', 'array-contains', clientId))
				: query(ref, where('isInternal', '==', true)),
		);
	}

	streamUser(userId: string) {
		return this.doc(userId).stream;
	}

	async addUser(id: string, data: User): Promise<void> {
		return this.doc(id).set({
			...data,
			isActive: true,
			createdAt: Timestamp.now(),
		});
	}
}
